import './progress_bar.css';

function ProgressBar({ step }) {
    const steps = ['Dados Pessoais', 'Formação', 'Experiência'];

    const getStepClass = (index) => {
        const currentStepIndex = step - 1;
        if (index < currentStepIndex) {
            return 'Completed';
        }
        if (index === currentStepIndex) {
            return 'Active';
        }
        return '';
    };

    return (
        <div className={`ProgressBar step-${step}`}>
            {steps.map((label, index) => (
                <div key={index} className={`Step ${getStepClass(index)}`}>
                    <div className="StepNumber">{index + 1}</div>
                    <div className="StepLabel">{label}</div>
                </div>
            ))}
        </div>
    );
}

export default ProgressBar;